import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderCommentThread';
import { AppState } from '../../../../../../types/store';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getFeaturedFolder } from '../../../../../selectors/folders';

export type StateProps = Pick<Props, 'currentUser' | 'featuredFolder'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  currentUser: getCurrentUser(state),
  featuredFolder: getFeaturedFolder(state),
});

export default connect(mapStateToProps);
